import { Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import theme from "../styles";

const useStyles = makeStyles({
  textContainer: {
    paddingLeft: "1em",
    paddingRight: "1em",
    paddingTop: "7em",
    margin: "0em 7em 4em 7em",
    [theme.breakpoints.down("sm")]: {
      margin: "0em",
      paddingTop: "5em",
      paddingLeft: "0em",
      paddingRight: "0em",
    },
  },
  InnerContainer: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      paddingLeft: "0em",
      paddingRight: "0em",
    },
  },
  SubInnerContainer: {
    maxWidth: "75%",
    textAlign: "left",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      width: "90%",
      paddingLeft: "0em",
      paddingRight: "0em",
    },
  },
  divider: {
    backgroundColor: theme.palette.primary.main,
    width: "80%",
    marginTop: "-2em",
    marginBottom: "3em",
    marginLeft: "50%",
    transform: "translateX(-50%)",
  },
});

export default function Privacy() {
  const classes = useStyles();
  return (
    <div className={classes.textContainer}>
      <Helmet>
        <title>Privacy Policy</title>
        <meta
          name="Privacy Policy Page"
          content="Privacy policy for our site"
        />
      </Helmet>

      <Typography
        variant="h2"
        gutterBottom={true}
        style={{ paddingBottom: "0.7em", color: theme.palette.primary.main }}
      >
        Privacy Policy
      </Typography>
      <Divider className={classes.divider} />
      <div className={classes.InnerContainer}>
        <div className={classes.SubInnerContainer}>
          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            Who we are{" "}
          </Typography>
          <Typography style={{ paddingBottom: "2em" }} gutterBottom={true}>
            Our website address is:{" "}
            <a href="https://humanizing-online-services-toolkit.netlify.app/">
              https://humanizing-online-services-toolkit.netlify.app/
            </a>{" "}
          </Typography>

          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            What personal data we collect and why we collect it
          </Typography>
          <Typography
            style={{ color: "black" }}
            gutterBottom={true}
            variant="h5"
          >
            Messages
          </Typography>
          <Typography style={{ paddingBottom: "2em" }} gutterBottom={true}>
            When visitors leave messages on the site we collect the data shown
            in the messages form, and also the visitor’s IP address and browser
            user agent string to help spam detection.
          </Typography>

          <Typography
            style={{ color: "black" }}
            gutterBottom={true}
            variant="h5"
          >
            Cookies
          </Typography>
          <p>
            If you leave a comment on ourblack site you may opt in to saving
            your name, email address and website in cookies. These are for your
            convenience so that you do not have to fill in your details again
            when you leave another comment. These cookies will last for one
            year.
          </p>
          <p>
            If you visit our login page, we will set a temporary cookie to
            determine if your browser accepts cookies. This cookie contains no
            personal data and is discarded when you close your browser.
          </p>
          <p style={{ paddingBottom: "2em" }}>
            If you edit or publish an article, an additional cookie will be
            saved in your browser. This cookie includes no personal data and
            simply indicates the post ID of the article you just edited. It
            expires after 1 day.
          </p>
          <Typography
            style={{ color: "black" }}
            gutterBottom={true}
            variant="h5"
          >
            Embedded content from other websites
          </Typography>
          <p>
            Articles on this site may include embedded content (e.g. videos,
            images, articles, etc.). Embedded content from other websites
            behaves in the exact same way as if the visitor has visited the
            other website.
          </p>
          <p style={{ paddingBottom: "2em" }}>
            These websites may collect data about you, use cookies, embed
            additional third-party tracking, and monitor your interaction with
            that embedded content, including tracking your interaction with the
            embedded content if you have an account and are logged in to that
            website.
          </p>
          <Typography
            style={{ color: "black" }}
            gutterBottom={true}
            variant="h5"
          >
            Analytics
          </Typography>
          <p>
            We use Matomo to collect anonymised data about visits to this
            website. This tells us which country, and in some cases which city,
            the IP address you are visiting from is based in, but no more than
            that. Matomo also tracks which pages on the site you visit, and
            which links you use to exit from the site.
          </p>

          <p>
            This data is recorded to allow us to improve the site, by increasing
            our understanding of how visitors use it.
          </p>

          <p style={{ paddingBottom: "2em" }}>
            If you have enabled the DoNotTrack option in your web browser (to
            say “I do not want to be tracked”) then Matomo will not track visits
            made to this site through the browser.
          </p>

          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            Who we share your data with
          </Typography>
          <p style={{ paddingBottom: "2em" }}>
            We will not share any data gathered from this website with anyone
            outside the HOST team.
          </p>

          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            How long we retain your data
          </Typography>
          <p>
            If you leave a comment, the comment and its metadata are retained
            indefinitely. This is so we can recognise and approve any follow-up
            comments automatically instead of holding them in a moderation
            queue.
          </p>
          <p style={{ paddingBottom: "2em" }}>
            The anonymised analytics data will be retained for the lifetime of
            the web site.
          </p>

          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            What rights you have over your data
          </Typography>
          <p style={{ paddingBottom: "2em" }}>
            If you have left comments on our site, you can request to receive an
            exported file of the personal data we hold about you, including any
            data you have provided to us. You can also request that we erase any
            personal data we hold about you. This does not include any data we
            are obliged to keep for administrative, legal, or security purposes.
          </p>

          <Typography
            style={{ color: "#660099" }}
            gutterBottom={true}
            variant="h4"
          >
            Where we send your data
          </Typography>
          <p style={{ paddingBottom: "2em" }}>
            Visitor comments may be checked through an automated spam detection
            service.
          </p>
        </div>
      </div>
    </div>
  );
}
